export default "__VITE_ASSET__CIDPDI89__"